import apiService from "./apiService";
import { AUTH_ENDPOINTS, PROFILE_ENDPOINTS } from "./endpoints";
import { buildForgotPasswordPayload, buildResetPasswordPayload } from "./payload";
import { login as rpcLogin } from "./postgre/authApi";
import { getProfileByEmail } from "./postgre/userApi";

export const influencerLogin = async (payload) => {
    return rpcLogin(payload);
};

export const getInfluencerProfile = async (email) => {
    return getProfileByEmail(email);
};

export const identityLogin = async (payload) => {
    const response = await apiService.post(AUTH_ENDPOINTS.IDENTITY_LOGIN, payload);
    return response?.data || {};
};

export const register = async (payload) => {
    const response = await apiService.post(AUTH_ENDPOINTS.REGISTER, payload);
    return response?.data;
};

export const registerKlaviyoProfile = async (payload) => {
    const response = await apiService.post(AUTH_ENDPOINTS.KLAVIYO_REGISTER, payload);
    return response?.data;
};

export const forgotPassword = async ({ email }) => {
    const response = await apiService.post(AUTH_ENDPOINTS.FORGOT_PASSWORD, buildForgotPasswordPayload(email));
    return response?.data;
};

export const resetPassword = async ({ email, token, password, confirmPassword }) => {
    const response = await apiService.post(
        AUTH_ENDPOINTS.RESET_PASSWORD,
        buildResetPasswordPayload({ email, token, password, confirmPassword })
    );
    return response?.data;
};

export const verifyTurnstile = async (token) => {
    try {
        const response = await apiService.post(AUTH_ENDPOINTS.TURNSTILE_VERIFY, { turnstile_token: token });
        return response?.data?.success === true;
    } catch {
        return false;
    }
};

export const sendOrderConfirmation = async (payload) => {
    const response = await apiService.post(AUTH_ENDPOINTS.SEND_ORDER_CONFIRMATION, payload);
    return response?.data;
};

export const getProfile = async () => {
    const response = await apiService.get(PROFILE_ENDPOINTS.ME);
    return response?.data;
};
